import ClearIcon from '@mui/icons-material/Clear';
import { FormControlLabel, Radio, RadioGroup, } from '@mui/material';
import { useFormik } from "formik"
import { useEffect } from "react"
import { Grid, IconButton } from "src/components"
import Card from "src/components/Card"
import CardContent from "src/components/CardContent"
import CardHeader from "src/components/CardHeader"
import DatePicker from "src/components/DatePicker"
import ParametreGrupEnum from "src/enums/ParametreGrupEnum"
import { translate } from "src/i18n/tHelper"
import VwKurumMailGonderimAyarlariDTO from "src/models/Settings/Generals/VwKurumMailGonderimAyarlariDTO"
import GnlParametreSelect from "src/parts/Genel/gnl.parametre.select"
import KurumAutoComplete from "src/parts/Kurum/kurum.autocomplete"
import OrgYetkiAutocomplete from "src/parts/Organizasyon/OrgYetkiAutocomplete"
import { useKurumMailGonderimAyarFiltreleMutation } from "src/services/geneltanimlar/KurumMailGonderimAyarlariApi"
import { useAppDispatch, useAppSelector } from "src/store"
import { KurumMailGonderimAyarlariSlice } from "src/store/Slices/GenelTanimlar/KurumMailGonderimAyarlariSlice"
import SnackbarUtils from "src/utils/SnackbarUtils"
import * as yup from 'yup';
interface KurumMailGonderimAyarlariProps { }
const translatePath = "pages|KurumMailGonderimAyarlari"



const KurumMailGonderimAyarlariAramaKriterleri = (props: KurumMailGonderimAyarlariProps): JSX.Element => {

    const state = useAppSelector(state => state.kurumMailGonderimAyarlari);
    const dispatch = useAppDispatch();
    const [filtre, filtreState] = useKurumMailGonderimAyarFiltreleMutation();

    const formik = useFormik<VwKurumMailGonderimAyarlariDTO>({
        enableReinitialize: true,
        initialValues: state.filtreKriterleri,
        validateOnChange: false,
        async onSubmit(values) {
            if (!filtreState.isLoading) {
                try {
                    await filtre(values)
                        .unwrap()
                        .then((response) => {


                            dispatch(KurumMailGonderimAyarlariSlice.actions.setData(response));

                        })
                        .catch((e) => {
                            SnackbarUtils.error(translate(translatePath, 'Hata.'));
                        });

                } catch (error: any) {
                    SnackbarUtils.error(error.message);
                }
            }
        },
        validationSchema: yup.object().shape({
            fkOrganizasyon: yup.string().trim().required('Organizasyon alanı zorunludur.'),
        })
    });

    useEffect(() => {
        if (state.searchHandler) {
            (async () => {
                await formik.submitForm();
                dispatch(KurumMailGonderimAyarlariSlice.actions.setSearchHandler(false));
            })();
        }
    }, [state.searchHandler])

    return (
        <Card>
            <CardHeader title={translate(translatePath, "Arama Kriterleri")} />
            <CardContent>
                <Grid container>
                    <Grid item sm={6} md={4} lg={3}>
                        <OrgYetkiAutocomplete
                            label={translate(translatePath, "Organizasyon")}
                            name="fkOrganizasyon"
                            required={true}
                            value={formik.values.fkOrganizasyon}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.fkOrganizasyon)}
                            helperText={formik.errors.fkOrganizasyon}

                        />
                    </Grid>
                    <Grid item sm={6} md={4} lg={3}>
                        <KurumAutoComplete
                            label={translate(translatePath, "Kurum")}
                            name="fkKurum"
                            value={formik.values.fkKurum}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.fkKurum)}
                            helperText={formik.errors.fkKurum}
                        />
                    </Grid>
                    <Grid item sm={6} md={4} lg={3} sx={{ display: "flex", position: "relative", alignItems: "center" }}>
                        <DatePicker
                            label={translate(translatePath, "Ekleme Tarihi")}
                            name="eklemeTarihi"
                            value={formik.values.eklemeTarihi}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.eklemeTarihi)}
                            helperText={formik.errors.eklemeTarihi}

                        />
                        {formik.values.eklemeTarihi && (
                            <IconButton
                                onClick={() => (formik.setFieldValue("eklemeTarihi", null))}
                                sx={{ position: "absolute", right: 30, }}
                            >
                                <ClearIcon fontSize='small' />
                            </IconButton>
                        )}
                    </Grid>

                    <Grid item sm={6} md={4} lg={3}>

                        <GnlParametreSelect
                            label={translate(translatePath, "Gönderim Yöntem")}
                            parametreType={ParametreGrupEnum.GonderimYontem}
                            name="gonderimYontem"
                            value={formik.values.gonderimYontem}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.gonderimYontem)}
                            helperText={formik.errors.gonderimYontem}
                        />
                    </Grid>
                    <Grid item sm={6} md={4} lg={3}>
                        <GnlParametreSelect
                            label={translate(translatePath, "Gönderim Süre Yöntem")}
                            parametreType={ParametreGrupEnum.GonderimSureYontem}
                            name="gonderimSureYontem"
                            value={formik.values.gonderimSureYontem}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.gonderimSureYontem)}
                            helperText={formik.errors.gonderimSureYontem}
                        />
                    </Grid>

                    <Grid item sm={6} md={4} lg={3}>
                        <RadioGroup
                            row
                            aria-labelledby="gonderimAktif-label"
                            name="gonderimAktif"
                            id="gonderimAktif"
                            value={formik.values.gonderimAktif}
                            onChange={formik.handleChange}
                            sx={{ justifyContent: 'center', display: 'flex', border: "1px solid rgb(206, 212, 218)", borderRadius: "8px" }}

                        >
                            <FormControlLabel value="E" labelPlacement="end" control={<Radio size='small' />} label={translate(translatePath, "Aktif")} />
                            <FormControlLabel value="H" labelPlacement="end" control={<Radio size='small' />} label={translate(translatePath, "Pasif")} />
                            <FormControlLabel value="Hepsi" labelPlacement="end" control={<Radio size='small' />} label={translate(translatePath, "Hepsi")} />

                        </RadioGroup>

                    </Grid>

                </Grid>
            </CardContent>
        </Card>
    )
}
export default KurumMailGonderimAyarlariAramaKriterleri